import React from "react";
import ReactDOM from "react-dom/client"; // 更新导入路径
import {Provider} from "react-redux";
import "./index.css";
import {createBrowserRouter, RouterProvider,redirect} from "react-router-dom";
import SignIn from "./auth/SignIn";
import {MsalProvider} from "@azure/msal-react";
import LoginPage from "./viewer/login/LoginPage"; // 确保路径正确
import {pca} from "./components/sso/authConfig";
import {queryClient} from "src/react-query";
import {QueryClientProvider} from "@tanstack/react-query";
import store from "src/store";
import {ColorTheme} from "./ColorTheme";
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container); // 使用 createRoot
import {MuiThemeProvider} from "@material-ui/core/styles";
import Layout from "./root/components/layout/Layout";
import VideoIndex from "./viewer/index/components/VideoIndex";
import VideoPage from "./viewer/videoPlayer/VideoPage";
import VideoSearch from "./viewer/search/components/VideoSearch";
import PresentersIndex from "./viewer/presenters/components/index/PresentersIndex";
import HomePage from "./viewer/index/components/HomePage";
import ProjectIndex from "./viewer/index/components/project/ProjectIndex";
import ProgramIndex from "./viewer/channel-detail/ProgramIndex";
import ChannelPages from "./viewer/index/components/program/ChannelPages";
import {LoginComplete} from "src/user/UserActions";
import UserApi from "src/user/UserApi";
import userService from "src/utils/UserService";
import {isEmpty} from "lodash";
import {SnackbarProvider} from "notistack";
import cotAxios from "./common/cotAxios";
function getRedirectPath(urlStr:string) {
    const url = new URL(urlStr);
    return encodeURIComponent(`${url.pathname}${url.search}`);
}
const authLoader = async (ctx) => {
    const email = userService.email;
    if (isEmpty(email)) {
        return redirect(`/login?redirect_uri=${getRedirectPath(ctx.request.url)}`);
    }
    try {
        const userInfo = await UserApi.GetUser(email);
        store.dispatch(LoginComplete(userInfo));

        return null;
    } catch (err) {
        userService.email = undefined;
        return redirect(`/login?redirect_uri=${getRedirectPath(ctx.request.url)}`);
    }
};
const videoIdLoader = async (ctx) => {
    try {
        const res = await cotAxios.get("/api/getVideoByVideoUUID",{
            params:{
                hash:ctx.params.id
            }
        });
        if (res.data.success) {
            console.log("in suceess");
            return res.data.data;
        } else {
            return {
                errorMsg:res.data.message ?? "該当する動画が存在しません、またはアクセス権限がありません。"
            };
        }
    } catch (error) {
        return {
            id:undefined,
            errorMsg:"該当する動画が存在しません、またはアクセス権限がありません。"
        };
    }
};
const router = createBrowserRouter([
    {
        path: "/login",
        element: <LoginPage/>
    },
    {
        path: "/signin",
        element: <SignIn/>
    },
    {
        path: "/auth/callback/",
        element: <div>ログイン中...</div>
    },
    {
        path: "/",
        element: <Layout/>,
        loader:authLoader,
        children: [
            {
                index: true,
                element: <HomePage/>
            },
            {
                path: "homepage",
                element: <HomePage/>
            },
            {
                path: "project",
                element: <ProjectIndex/>
            },
            {
                path: "channels",
                element: <ChannelPages/>
            },
            {
                path: "channel/:id",
                element: <ProgramIndex/>
            },
            {
                path: "videos",
                element: <VideoIndex/>
            },
            {
                id:"videoDetail",
                path: "video/:id",
                element: <VideoPage/>,
                loader:videoIdLoader
            },
            {
                path: "search",
                element: <VideoSearch/>
            },
            {
                path: "presenter",
                element: <PresentersIndex/>
            }
        ]
    }
]);
root.render(
    <React.StrictMode>
        <MsalProvider instance={pca}>
            <QueryClientProvider client={queryClient}>
                {/*TODO V4 change to v6 */}
                <MuiThemeProvider theme={ColorTheme}>
                    <Provider store={store}>
                        <SnackbarProvider
                            maxSnack={1}
                            hideIconVariant={false}
                            dense={true}
                            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                        >
                            <RouterProvider router={router}/>
                        </SnackbarProvider>
                    </Provider>
                </MuiThemeProvider>
            </QueryClientProvider>
        </MsalProvider>
    </React.StrictMode>
);
